import { expressList } from "@/mocks/gossipData";
import Reveal from "./Reveal";

const toneMap: Record<string, string> = {
  first: "bg-accent-100 text-accent-700",
  speed: "bg-secondary-100 text-secondary-700",
  exclusive: "bg-primary-100 text-primary-700",
  proof: "bg-foreground-950/5 text-foreground-700",
  hot: "bg-primary-50 text-primary-700",
};

export default function ExpressList() {
  return (
    <section id="express" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                最新新瓜 · 随时刷新
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                首发速递 · 抢在热搜前
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                标题加短摘要，一眼抓住重点；首发、独家、实锤分级标注，跟得上就点进来看完整复盘。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {expressList.map((row, i) => (
            <Reveal key={row.title} delay={i * 60}>
              <a href="#express" className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6">
                <span className="w-6 shrink-0 text-center text-xs font-bold text-secondary-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span
                  className={`hidden w-16 shrink-0 items-center justify-center rounded-full px-2.5 py-1 text-[11px] font-semibold sm:flex ${toneMap[row.tone] || toneMap.speed}`}
                >
                  {row.tag}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-[15px] font-bold text-foreground-950 group-hover:text-primary-600">
                    {row.title}
                  </h3>
                  <p className="mt-1 hidden truncate text-sm text-foreground-600 sm:block">{row.summary}</p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1 text-right">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line text-[11px]" />
                    {row.time}
                  </span>
                  <span className="flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-0.5">
                      <i className="ri-eye-line" />
                      {row.views}
                    </span>
                    <span className="flex items-center gap-0.5 font-medium text-foreground-700">
                      <i className="ri-chat-3-fill text-accent-600" />
                      {row.comments.toLocaleString()}
                    </span>
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}